const RUPEE_AMOUNT = new Intl.NumberFormat('en-PK', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * An amount as a bill shows it, `1,250.00` — on screen, on the slip and in a
 * dashboard line alike. No currency prefix: a table column or a slip cell
 * labels that once.
 */
export function formatRupeeAmount(value: number): string {
  return RUPEE_AMOUNT.format(value);
}
